// in src/posts.js
import React from 'react';
import { Filter, BooleanField, DeleteButton, DateField, RichTextField, SimpleShowLayout, Show, ShowButton, SimpleList, BooleanInput, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import constants from './../shared/constants';
import { useMediaQuery } from '@mui/material';

//Utils
import Validators from './renderFields/validatorsFields';

const TermsFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="title" alwaysOn />
    </Filter>
);

export const TermsList = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Políticas de Privacidad" filters={<TermsFilter />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.title}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="title" label="Título"/>
                    <RichTextField source="description" label="Descripción"/>
                    <BooleanField source="state" label="Estado"/>
                    <EditButton />
                    <ShowButton />
                    <DeleteButton />
                </Datagrid>
            )}
        </List>
    );
};

const TermsTitle = ({ record }) => {
    return <span>Terminos y Condiciones</span>;
};

export const TermsCreate = (props) => (
    <Create {...props} title="Crear Políticas de Privacidad">
        <SimpleForm>
            <TextInput source="title" label="Título" validate={[Validators.required]}/>
            <RichTextInput source="description" label="Descripción" validate={[Validators.required]} isRequired={true} validation={{ required: true }}/>
            <BooleanInput source="state" label="Estado" defaultValue={true}/>
        </SimpleForm>
    </Create>
);

export const TermsEdit = (props) => (
    <Edit title={<TermsTitle />} {...props}>
        <SimpleForm>
            <TextInput source="id" disabled/>
            <TextInput source="title" label="Título" validate={[Validators.required]}/>
            <RichTextInput source="description" label="Descripción" validate={[Validators.required]} isRequired={true} validation={{ required: true }}/>
            <BooleanInput source="state" label="Estado"/>
        </SimpleForm>
    </Edit>
);


export const TermsShow = (props) => (
    <Show title={<TermsTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="title" label="Título"/>
            <RichTextField source="description" label="Descripción"/>
            <BooleanField source="state" label="Estado"/>
            <DateField label="Fecha de Actualización" source="updatedAt" />
            <DateField label="Fecha de Publicación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);
